import { render, staticRenderFns } from "./MenuOrderFilters.vue?vue&type=template&id=5d73d1d0"
import script from "./MenuOrderFilters.vue?vue&type=script&lang=js"
export * from "./MenuOrderFilters.vue?vue&type=script&lang=js"
import style0 from "./MenuOrderFilters.vue?vue&type=style&index=0&id=5d73d1d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports